export default {
  getMonthlyInstalment() {
    return {
      data: [
        {
          STATEMENT_DATE: '01',
        },
        {
          STATEMENT_DATE: '02',
        },
        {
          STATEMENT_DATE: '03',
        },
        {
          STATEMENT_DATE: '04',
        },
        {
          STATEMENT_DATE: '05',
        },
        {
          STATEMENT_DATE: '06',
        },
        {
          STATEMENT_DATE: '07',
        },
        {
          STATEMENT_DATE: '08',
        },
        {
          STATEMENT_DATE: '09',
        },
        {
          STATEMENT_DATE: '10',
        },
        {
          STATEMENT_DATE: '11',
        },
        {
          STATEMENT_DATE: '12',
        },
        {
          STATEMENT_DATE: '13',
        },
        {
          STATEMENT_DATE: '14',
        },
        {
          STATEMENT_DATE: '15',
        },
        {
          STATEMENT_DATE: '16',
        },
        {
          STATEMENT_DATE: '17',
        },
        {
          STATEMENT_DATE: '18',
        },
        {
          STATEMENT_DATE: '19',
        },
        {
          STATEMENT_DATE: '20',
        },
        {
          STATEMENT_DATE: '21',
        },
        {
          STATEMENT_DATE: '22',
        },
        {
          STATEMENT_DATE: '23',
        },
        {
          STATEMENT_DATE: '24',
        },
        {
          STATEMENT_DATE: '25',
        },
        {
          STATEMENT_DATE: '26',
        },
        {
          STATEMENT_DATE: '27',
        },
        {
          STATEMENT_DATE: '28',
        },
        {
          STATEMENT_DATE: '29',
        },
        {
          STATEMENT_DATE: '30',
        },
        {
          STATEMENT_DATE: '31',
        },
      ],
    };
  },
};
